import React, { useState, useEffect, useCallback } from "react";
import {
    Table,
    Form,
    Menu,
    Icon,
    Button,
    Loader,
    Header,
    Modal,
    Radio,
    Checkbox,
    Segment,
    Dropdown,
    Input,
    Item,
} from "semantic-ui-react";
import {
    Container,
    Title,
    Field,
    Label,
    InputFile,
    InputText,
    InputLabel
} from "../../../../../pages/Admin/Empresas/criarEmpresas/styled";

import { voittoapi as api } from "../../../../../services/apis";
import swal from 'sweetalert';


const Planos = (props) => {
    const [planos, setPlanos] = useState({
        cursoID: '',
        licenca: '',
        acesso: '',
    })
    const [view, setView] = useState(props.valor)
    const [open, setOpen] = useState(false);
    const [cursoValue, setCursoValue] = useState([])



    useEffect(() => {
        loadCursos()

    }, [])

    const loadCursos = () => {
        api
            .get('/cursos-ids')
            .then((res) => {
                const stateOptions = res.data.map((curso) => ({
                    text: curso.curso + ' - ' + curso.id,
                    value: curso.id,
                }))
                setCursoValue([...cursoValue, ...stateOptions])
            }).catch((err) => {
                swal("Ops!, Ocorreu um erro", err, "error")
            })
    }

    const addTabela = useCallback((id, licenca, acesso) => {
        const value = [...view, { cursoID: id, licenca: licenca, acesso: acesso }]
        setView([...view, { cursoID: id, licenca: licenca, acesso: acesso }])

        handleValue(value);

    }, [view])
    const deleteTabela = useCallback((id) => {

        const newCurso = view.filter(curso => curso.cursoID !== id);
        console.log(newCurso);
        setView(newCurso);
        handleValue(newCurso);

    }, [view])

    const handleValue = (valor) => {
        props.handlePlanos(valor)


    }

    return (
        <>
            <Modal
                closeIcon
                open={open}
                trigger={<Button><Icon name='add' />Adicionar plano</Button>}
                onClose={() => setOpen(false)}
                onOpen={() => setOpen(true)}
            >
                <Header content="Plano Empresa" />
                <Modal.Content>
                    <div>
                        <Label>Curso:</Label>
                        <Dropdown
                            placeholder='Escolha um curso'
                            fluid
                            search
                            selection

                            options={cursoValue}
                            onChange={(e, data) => { setPlanos({ ...planos, cursoID: data.value }); console.log(data.text) }}
                        />
                    </div>
                    <div>
                        <Label>Número de Licenças:</Label>
                        <Input
                            type="number"

                            onChange={(e) => setPlanos({ ...planos, licenca: e.target.value })}
                        />

                    </div>
                    <div>
                        <Label>Tempo de Acesso (Dias)</Label>
                        <Input
                            type="number"

                            onChange={(e) => setPlanos({ ...planos, acesso: e.target.value })}
                        />

                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        color="green"
                        onClick={() => {
                            setOpen(false);
                            addTabela(planos.cursoID, planos.licenca, planos.acesso);

                        }}
                    >
                        <Icon name="checkmark" /> confirmar
              </Button>
                    <Button
                        color="red"
                        onClick={() => {
                            setOpen(false);

                        }}
                    >
                        <Icon name="remove" /> cancelar
              </Button>
                </Modal.Actions>
            </Modal>


            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Curso</Table.HeaderCell>
                        <Table.HeaderCell>Licenças</Table.HeaderCell>
                        <Table.HeaderCell>Tempo de Acesso</Table.HeaderCell>
                        <Table.HeaderCell>Ações</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {view.map((curso) => (
                        <Table.Row>
                            <Table.Cell>
                                [{curso.cursoID}]
                </Table.Cell>
                            <Table.Cell>{curso.licenca}</Table.Cell>
                            <Table.Cell>{curso.acesso}</Table.Cell>
                            <Table.Cell>
                                <>
                                    <Button icon="trash icon" info="delete"
                                        onClick={() => { deleteTabela(curso.cursoID) }}
                                    ></Button>
                                </>
                            </Table.Cell>
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>
        </>
    )
}

export default Planos